import sepmLogo from '../assets/sepm-logo.png'
import about from '../assets/images/About.png'
import addFixedMapping from '../assets/images/Add-Fixed-Mapping.png'
import addLogicalAttributeModal from '../assets/images/Add-Logical-Attribute-Modal.png'
import addLogicalCollectionModal from '../assets/images/Add-Logical-Collection-Modal.png'
import addValueMappingModal from '../assets/images/Add-Value-Mapping-Modal.png'
import attributeTable from '../assets/images/Attribute-Table.png'
import authoriseApplication from '../assets/images/Authorise-Application.png'
import authorizationSuccessful from '../assets/images/Authorization-Succesful.png'
import autoMapModal from '../assets/images/Auto-Map-Modal.png'
import autocadSourceConnection from '../assets/images/AutoCAD-Source-Model-Connection.png'
import connectIdAndDelete from '../assets/images/Connect-Id-and-Connect-Delete.png'
import currentTransferLogger from '../assets/images/Current-Transfer-Logger.png'
import formatDropdown from '../assets/images/Format-Dropdown.png'
import fullScreenDarkMode from '../assets/images/Full-Screen-Dark-Mode.png'
import fullScreenLightMode from '../assets/images/Full-Screen-Light-Mode.png'
import globalLogSettingsFormat from '../assets/images/Global-Log-Settings-Log-Format.png'
import globalLogSettingsLanguage from '../assets/images/Global-Log-Settings-Log-Language.png'
import globalLogSettingsLevel from '../assets/images/Global-Log-Settings-Log-level.png'
import mapView from '../assets/images/Map-View.png'
import mappingExample from '../assets/images/Mapping-Example.png'
import modelFilter from '../assets/images/Model-Filter.png'
import scratchTransferDetailsPostgis from '../assets/images/Scratch-Transfer-Details-PostGIS.png'
import signInScreen1 from '../assets/images/Sign-In-Screen-1.png'
import signInScreen2 from '../assets/images/Sign-In-Screen-2.png'
import signInSuccessful from '../assets/images/Sign-in-Successfull.png'
import sourceModelConfigurationModal from '../assets/images/Source-Model-Condiguration-Modal.png'
import sourceConnectionPostgis from '../assets/images/Source-Model-Connection-PostGIS.png'
import sourceConnectionTextCsv from '../assets/images/Source-Model-Connection-Text-CSV-Excel.png'
import sourceModelTreePostgis from '../assets/images/Source-Model-Tree-PostGIS.png'
import styleExportAccordion from '../assets/images/Style-Export-Accordion.png'
import targetConnectionPostgis from '../assets/images/Target-Model-Connection-PostGIS.png'
import transferHistory from '../assets/images/Transfer-History.png'
import transferViewLog from '../assets/images/Transfer-View-Log.png'
import verticalMiddlePanel from '../assets/images/Vertical-Middle-Button-Panel.png'

/** Product screenshots under `src/assets/images` (Vite-bundled URLs). */
export const media = {
  sepmLogo,
  hero: sepmLogo,
  about,
  addFixedMapping,
  addLogicalAttributeModal,
  addLogicalCollectionModal,
  addValueMappingModal,
  attributeTable,
  authoriseApplication,
  authorizationSuccessful,
  autoMapModal,
  autocadSourceConnection,
  connectIdAndDelete,
  currentTransferLogger,
  formatDropdown,
  fullScreenDarkMode,
  fullScreenLightMode,
  globalLogSettingsFormat,
  globalLogSettingsLanguage,
  globalLogSettingsLevel,
  mapView,
  mappingExample,
  modelFilter,
  scratchTransferDetailsPostgis,
  signInScreen1,
  signInScreen2,
  signInSuccessful,
  sourceModelConfigurationModal,
  sourceConnectionPostgis,
  sourceConnectionTextCsv,
  sourceModelTreePostgis,
  styleExportAccordion,
  targetConnectionPostgis,
  transferHistory,
  transferViewLog,
  verticalMiddlePanel,
} as const

export type MediaKey = keyof typeof media
